import React, { useContext, useState, useEffect } from "react";
import { Form, useNavigate } from "react-router-dom";
import classes from "./CheckUpPatientDetails.module.css";
import WaitingContext from "../../../store/waitingListContext";
import { getAuthToken } from "../../../util/auth";
import { getApiChara } from "../../../util/getApi";
import AuthContext from "../../../store/auth-context";
import Modal from "../../UI/Modal";
import DataModal from "../../UI/DataModal";
import PatientActionModal from "../../UI/PatientActionModal";
import { FaIdCard, FaUser, FaBirthdayCake, FaPhoneAlt, FaEdit, FaRupeeSign, FaHashtag, FaCalendarAlt, FaMicrophone } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import specialityFields from "../../../util/specialityFields.json";
import { calculateAgeDetailed } from "../../../util/ageCalculator";

const CheckedDetails = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const authCtx = useContext(AuthContext);
    const checkPatient = useContext(WaitingContext);
    const checkPatientData = checkPatient.waitingPatient;

    const [outstandingAmount, setOutstandingAmount] = useState(null);
    const [patientAge, setPatientAge] = useState({
        years: 0,
        months: 0,
        days: 0,
        text: ""
    });

    const [diagnosis, setDiagnosis] = useState("");
    const [diagnosisList, setDiagnosisList] = useState([]);
    const [weight, setWeight] = useState(
        checkPatientData ? checkPatientData.weight : ""
    );
    const [bps, setBps] = useState(checkPatientData ? checkPatientData.bp1 : "");
    const [bpd, setBpd] = useState(checkPatientData ? checkPatientData.bp2 : "");
    const [pulse, setPulse] = useState(
        checkPatientData ? checkPatientData.pulse : ""
    );
    const [temp, setTemp] = useState(
        checkPatientData ? checkPatientData.temperature : ""
    );
    const [spo2, setSpo2] = useState(
        checkPatientData ? checkPatientData.spo2 : ""
    );
    const [allergy, setAllergy] = useState(
        checkPatientData ? checkPatientData.allergy : ""
    );
    const [complaint, setComplaint] = useState("");
    const [advice, setAdvice] = useState("");
    const [adviceList, setAdviceList] = useState([]);
    const [modalData, setmodalData] = useState({});
    const [success, setIsSuccess] = useState();
    const [billingDate, setBillingDate] = useState("");
    const [showEditModal, setShowEditModal] = useState(false);

    // Standardized Clinical Fields
    const [lmp, setLmp] = useState("");
    const [edd, setEdd] = useState("");
    const [length, setLength] = useState(checkPatientData?.length || "");
    const [hc, setHc] = useState(checkPatientData?.hc || "");
    const [nextAppointment, setNextAppointment] = useState(checkPatientData?.nextAppointment || checkPatientData?.next_appointment || "");
    const [notes, setNotes] = useState(checkPatientData?.notes || "");
    const [isHistoryLmp, setIsHistoryLmp] = useState(false);

    const [isListeningDiagnosis, setIsListeningDiagnosis] = useState(false);
    const [isListeningComplaint, setIsListeningComplaint] = useState(false);
    const [isListeningAdvice, setIsListeningAdvice] = useState(false);
    const [isListeningNotes, setIsListeningNotes] = useState(false);

    const handleVoiceInputForDiagnosis = () => {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            alert(t("Speech Recognition API is not supported in this browser. Please use Chrome."));
            return;
        }
        if (isListeningDiagnosis) return;

        const recognition = new SpeechRecognition();
        recognition.lang = 'en-IN';
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;

        recognition.onstart = () => setIsListeningDiagnosis(true);
        recognition.onresult = (event) => {
            let transcript = event.results[0][0].transcript;
            if (transcript) {
                const lowerTranscript = transcript.toLowerCase();
                let shouldSearch = false;
                
                if (lowerTranscript.endsWith("enter") || lowerTranscript.endsWith("search")) {
                    shouldSearch = true;
                    transcript = transcript.replace(/enter$/i, "").replace(/search$/i, "").trim();
                } else if (lowerTranscript.includes("enter") || lowerTranscript.includes("search")) {
                    shouldSearch = true;
                    transcript = transcript.replace(/enter/ig, "").replace(/search/ig, "").trim();
                }

                setDiagnosis(prev => {
                    const newValue = prev ? (prev + " " + transcript).trim() : transcript.trim();
                    setTimeout(() => fetchDiagnosisSuggestions(newValue), 0);
                    
                    if (shouldSearch) {
                        setTimeout(() => onSearchPrescriptionType(newValue), 100);
                    }
                    
                    return newValue;
                });
            }
        };
        recognition.onerror = () => setIsListeningDiagnosis(false);
        recognition.onend = () => setIsListeningDiagnosis(false);
        recognition.start();
    };

    const handleVoiceInputForComplaint = () => {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            alert(t("Speech Recognition API is not supported in this browser. Please use Chrome."));
            return;
        }
        if (isListeningComplaint) return;

        const recognition = new SpeechRecognition();
        recognition.lang = 'en-IN';
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;

        recognition.onstart = () => setIsListeningComplaint(true);
        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            if (transcript) {
                setComplaint(prev => prev ? prev + " " + transcript : transcript);
            }
        };
        recognition.onerror = () => setIsListeningComplaint(false);
        recognition.onend = () => setIsListeningComplaint(false);
        recognition.start();
    };

    const handleVoiceInputForAdvice = () => {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            alert(t("Speech Recognition API is not supported in this browser. Please use Chrome."));
            return;
        }
        if (isListeningAdvice) return;

        const recognition = new SpeechRecognition();
        recognition.lang = 'en-IN';
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;

        recognition.onstart = () => setIsListeningAdvice(true);
        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            if (transcript) {
                setAdvice(prev => {
                    const newValue = prev ? prev + " " + transcript : transcript;
                    setTimeout(() => fetchAdviceSuggestions(newValue), 0);
                    return newValue;
                });
            }
        };
        recognition.onerror = () => setIsListeningAdvice(false);
        recognition.onend = () => setIsListeningAdvice(false);
        recognition.start();
    };

    const handleVoiceInputForNotes = () => {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            alert(t("Speech Recognition API is not supported in this browser. Please use Chrome."));
            return;
        }
        if (isListeningNotes) return;

        const recognition = new SpeechRecognition();
        recognition.lang = 'en-IN';
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;

        recognition.onstart = () => setIsListeningNotes(true);
        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            if (transcript) {
                setNotes(prev => prev ? prev + " " + transcript : transcript);
            }
        };
        recognition.onerror = () => setIsListeningNotes(false);
        recognition.onend = () => setIsListeningNotes(false);
        recognition.start();
    };

    const pulseMicStyles = `
        @keyframes pulse-mic {
            0% { transform: scale(1); }
            50% { transform: scale(1.2); }
            100% { transform: scale(1); }
        }
    `;

    // 🆕 Validate pre-filled LMP on mount
    useEffect(() => {
        const rawLmp = checkPatientData?.lmp || checkPatientData?.Lmp;
        if (rawLmp) {
            let lmpStr = rawLmp;
            if (Array.isArray(rawLmp)) {
                lmpStr = `${rawLmp[0]}-${String(rawLmp[1]).padStart(2, '0')}-${String(rawLmp[2]).padStart(2, '0')}`;
            }

            const lmpDate = new Date(lmpStr);
            const oneYearAgo = new Date();
            oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

            if (!isNaN(lmpDate.getTime()) && lmpDate >= oneYearAgo) {
                setLmp(lmpStr);
                // Also set EDD if available or it will be calculated by the other effect
                const rawEdd = checkPatientData?.edd || checkPatientData?.Edd;
                if (rawEdd) {
                    if (Array.isArray(rawEdd)) {
                        setEdd(`${rawEdd[0]}-${String(rawEdd[1]).padStart(2, '0')}-${String(rawEdd[2]).padStart(2, '0')}`);
                    } else {
                        setEdd(rawEdd);
                    }
                }
            } else {
                console.log("Old or invalid LMP detected, clearing field:", rawLmp);
                setLmp("");
                setEdd("");
            }
        }
    }, [checkPatientData]);

    const speciality = (authCtx.hospitalData?.selectSpecialities || "general").toLowerCase();
    const visibleFields = specialityFields[speciality] || specialityFields["general"];

    // Fetch and check if we should pull LMP from history (within 6 months)
    useEffect(() => {
        const fetchAndApplyHistoryLmp = async () => {
            // Only try if current LMP is NOT already set in the current checkup object
            if (!checkPatientData?.patientId?.patientId || checkPatientData?.lmp || checkPatientData?.Lmp) return;

            // If already has a value in state (manual or partially loaded), also skip
            if (lmp) return;

            const token = getAuthToken();
            const apiChar = getApiChara();
            const apiUrl = `${apiChar}/patient/getPatientHistoryById/${checkPatientData.patientId.patientId}`;

            try {
                const response = await fetch(apiUrl, {
                    headers: { Authorization: "Bearer " + token },
                });
                if (!response.ok) return;
                const history = await response.json();

                const sixMonthsAgo = new Date();
                sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

                // Most recent first
                const sortedHistory = history.sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime));

                const recentLmpCheckup = sortedHistory.find(h => {
                    const lmpVal = h.lmp || h.Lmp;
                    if (!lmpVal) return false;
                    const checkupDate = new Date(h.dateTime);
                    return checkupDate >= sixMonthsAgo;
                });

                if (recentLmpCheckup) {
                    const foundLmp = recentLmpCheckup.lmp || recentLmpCheckup.Lmp;
                    let formattedLmp = foundLmp;
                    if (Array.isArray(foundLmp)) {
                        formattedLmp = `${foundLmp[0]}-${String(foundLmp[1]).padStart(2, '0')}-${String(foundLmp[2]).padStart(2, '0')}`;
                    }
                    setLmp(formattedLmp);
                    setIsHistoryLmp(true);
                }
            } catch (err) {
                console.error("Error checking history LMP:", err);
            }
        };

        if (speciality === "gynaecology" || visibleFields.includes("lmp")) {
            fetchAndApplyHistoryLmp();
        }
    }, [checkPatientData?.patientId?.patientId, speciality]);

    // LMP to EDD calculation
    useEffect(() => {
        if (lmp) {
            const lmpDate = new Date(lmp);
            if (!isNaN(lmpDate.getTime())) {
                const eddDate = new Date(lmpDate);
                eddDate.setDate(eddDate.getDate() + 280); // Naegele's rule approximation (LMP + 9 months + 7 days)
                setEdd(eddDate.toISOString().split('T')[0]);
            }
        }
    }, [lmp]);

    useEffect(() => {
        if (checkPatientData?.patientId?.dob) {
            const ageData = calculateAgeDetailed(checkPatientData?.patientId?.dob);
            setPatientAge(ageData);
        }
    }, [checkPatientData?.patientId?.dob]);

    useEffect(() => {
        if (!billingDate) {
            const now = new Date();
            const localISOTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
                .toISOString()
                .slice(0, 16);
            setBillingDate(localISOTime);
        }
    }, []);

    const fillExistingMedicineHandler = (existingMedData) => {
        const updated = [...(props.prescrbedMedicines || []), ...existingMedData];
        props.onGetMedicineDetailsHandler(updated);
    }

    const onDataCloseHandler = () => {
        setmodalData({});
    }

    const handleDiagnosisChange = (e) => {
        const value = e.target.value;
        setDiagnosis(value);
        fetchDiagnosisSuggestions(value);
    };

    const fetchDiagnosisSuggestions = async (term) => {
        if (!term || term.trim() === "") return;
        const token = getAuthToken();
        try {
            const apiChar = getApiChara();
            const apiUrl = `${apiChar}/diagnosis/${encodeURIComponent(term)}`;
            const response = await fetch(apiUrl, {
                headers: { Authorization: "Bearer " + token },
            });
            if (!response.ok) throw new Error("Failed to fetch diagnosis");
            const data = await response.json();
            setDiagnosisList(data.map((d) => d.diagnosisName));
        } catch (error) {
            console.error("Error fetching diagnosis suggestions:", error);
        }
    };

    const handleAdviceChange = (e) => {
        const value = e.target.value;
        setAdvice(value);
        fetchAdviceSuggestions(value);
    };

    const fetchAdviceSuggestions = async (term) => {
        if (!term || term.trim() === "") return;
        const token = getAuthToken();
        try {
            const apiChar = getApiChara();
            const apiUrl = `${apiChar}/advice/${encodeURIComponent(term)}`;
            const response = await fetch(apiUrl, {
                headers: { Authorization: "Bearer " + token },
            });
            if (!response.ok) throw new Error("Failed to fetch advice");
            const data = await response.json();
            setAdviceList(data.map((a) => a.adviceName));
        } catch (error) {
            console.error("Error fetching advice suggestions:", error);
        }
    };

    const onErrorCloseHandler = () => {
        setIsSuccess(null);
    };

    useEffect(() => {
        const bodycheckdata = {
            weight: weight ? `${weight} kg` : "",
            bps,
            bpd,
            pulse,
            temp,
            spo2,
            complaint,
            advice,
            allergy,
            diagnosis,
            billingDate,
            lmp,
            edd,
            length,
            hc,
            nextAppointment: nextAppointment,
            notes
        };
        props.onGetCheckupDetailsHandler(bodycheckdata);
    }, [weight, bps, bpd, pulse, temp, spo2, complaint, advice, allergy, diagnosis, billingDate, lmp, edd, length, hc, nextAppointment, notes]);

    const onSearchPrescriptionType = async (searchDiagnosis = diagnosis) => {
        const queryStr = typeof searchDiagnosis === 'string' ? searchDiagnosis : diagnosis;
        if (!queryStr.trim()) {
            setIsSuccess({
                message: t("Please enter prescription name"),
                title: t("Required"),
            });
            return;
        }
        const token = getAuthToken();
        const apiChar = getApiChara();
        const apiUrl = `${apiChar}/savedPrescription/getSavedPrescriptionListByDiagnosis?diagnosis=${encodeURIComponent(queryStr.trim())}`;
        try {
            const response = await fetch(apiUrl, {
                headers: {
                    Authorization: "Bearer " + token,
                },
            });
            if (!response.ok) {
                throw new Error("Could Not fetch searched Prescription details");
            }
            const searchedPrescri = await response.json();
            if (Object.keys(searchedPrescri).length === 0) {
                setIsSuccess({
                    message: t("No Prescription Found..."),
                    title: t("Available Prescriptions"),
                });
            }
            setmodalData(searchedPrescri);
        } catch (error) {
            console.error("Error fetching: ", error);
        }
    };

    useEffect(() => {
        const fetchOutstandingAmount = async () => {
            if (!checkPatientData?.patientId?.patientId) return;
            const token = getAuthToken();
            try {
                const apiChar = getApiChara();
                const apiUrl = `${apiChar}/billings/getOutstandingAmountByPatientId?patientId=${checkPatientData.patientId.patientId}`;
                const response = await fetch(apiUrl, {
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                });
                if (!response.ok) throw new Error("Failed");
                const amount = await response.json();
                setOutstandingAmount(amount);
            } catch (error) {
                setOutstandingAmount(0);
            }
        };
        fetchOutstandingAmount();
    }, [checkPatientData?.patientId?.patientId]);

    const today = new Date().toISOString().split('T')[0];
    const twelveMonthsAgo = new Date();
    twelveMonthsAgo.setMonth(twelveMonthsAgo.getMonth() - 12);
    const minLmpDate = twelveMonthsAgo.toISOString().split('T')[0];

    return (
        <>
            <style>{pulseMicStyles}</style>
            {success && (
                <Modal
                    message={success.message}
                    title={success.title}
                    OnConfirmBlock={onErrorCloseHandler}
                />
            )}
            {Object.keys(modalData).length > 0 && (
                <DataModal
                    prescriptions={modalData}
                    OnCloseModalBlock={onDataCloseHandler}
                    onAddToMedicineTable={fillExistingMedicineHandler}
                />
            )}
            <PatientActionModal
                show={showEditModal}
                onHide={() => setShowEditModal(false)}
                patientData={checkPatientData?.patientId}
                mode="EDIT"
                onSuccess={(updatedPatient) => {
                    if (checkPatient && checkPatient.OnAddedcheckUp) {
                        checkPatient.OnAddedcheckUp({
                            ...checkPatientData,
                            patientId: updatedPatient
                        });
                    }
                }}
            />
            <div className="container-fluid p-0 mt-1">
                <article className={classes.patient}>
                    <div className={classes.patientInfoHeader}>
                        <div className={classes.infoItem}>
                            <FaIdCard /> <span>{t("Patient Id")}: {checkPatientData?.patientId?.patientId || ""}</span>
                        </div>
                        <div className={classes.infoItem}>
                            <FaUser /> <span>
                                {checkPatientData
                                    ? `${checkPatientData?.patientId?.firstName || ""} ${checkPatientData?.patientId?.middleName || ""} ${checkPatientData?.patientId?.lastName || ""}${checkPatientData?.patientId?.nickName ? ` (${checkPatientData?.patientId?.nickName})` : ""}`
                                    : ""}
                            </span>
                        </div>
                        <div className={classes.infoItem}>
                            <FaBirthdayCake /> <span>
                                {checkPatientData?.patientId?.dob
                                    ? `${patientAge?.years}${t("Y")} ${patientAge?.months}${t("M")} ${patientAge?.days}${t("D")}`
                                    : (checkPatientData?.patientId?.age ? `${checkPatientData.patientId.age} ${t("Y")}` : "-")}
                            </span>
                        </div>
                        {checkPatientData?.patientId?.mobile && (
                            <div className={classes.infoItem}>
                                <FaPhoneAlt /> <span>{checkPatientData.patientId.mobile}</span>
                            </div>
                        )}
                        <button
                            className={classes.infoItem}
                            onClick={() => setShowEditModal(true)}
                            title={t("Edit Patient")}
                            style={{ border: '1px solid rgba(255, 255, 255, 0.4)', background: 'rgba(255, 255, 255, 0.15)' }}
                        >
                            <FaEdit /> <span>{t("Edit Patient")}</span>
                        </button>
                        <div className={classes.infoItem} title={t("Outstanding Amount")}>
                            <FaRupeeSign /> <span>{t("O.A")} : {outstandingAmount !== null ? outstandingAmount : "--"}</span>
                        </div>
                    </div>
                    <div className={classes.cardview} style={{ borderRadius: '0 0 10px 10px', marginTop: '0' }}>
                        <Form className={classes.form}>
                            <div className="row py-0 g-1">
                                <div className="col-md-3 col-6">
                                    <label className={classes.label} htmlFor="billingDate">{t("Date")}</label>
                                    <input className="form-control" type="datetime-local" id="billingDate" value={billingDate} onChange={(e) => setBillingDate(e.target.value)} />
                                </div>
                                <div className="col-md-3 col-6">
                                    <label className={classes.label} htmlFor="weight">{t("Weight (kg)")}</label>
                                    <input id="weight" type="number" name="weight" value={weight} onChange={(e) => setWeight(e.target.value)} />
                                </div>
                                <div className="col-md-3 col-6">
                                    <label className={classes.label} htmlFor="bpsystolic">{t("BP (Sys)")}</label>
                                    <input id="bpsystolic" type="number" name="bpsystolic" value={bps} onChange={(e) => setBps(e.target.value)} />
                                </div>
                                <div className="col-md-3 col-6">
                                    <label className={classes.label} htmlFor="bpdiastolic">{t("BP (Dia)")}</label>
                                    <input id="bpdiastolic" type="number" name="bpdiastolic" value={bpd} onChange={(e) => setBpd(e.target.value)} />
                                </div>
                                <div className="col-md-3 col-6">
                                    <label className={classes.label} htmlFor="pulse">{t("Pulse")}</label>
                                    <input id="pulse" type="number" name="pulse" value={pulse} onChange={(e) => setPulse(e.target.value)} />
                                </div>
                                <div className="col-md-2 col-6">
                                    <label className={classes.label} htmlFor="temperature">{t("Temperature")}</label>
                                    <input id="temperature" type="number" name="temperature" value={temp} onChange={(e) => setTemp(e.target.value)} />
                                </div>
                                <div className="col-md-2 col-6">
                                    <label className={classes.label} htmlFor="SpO2">{t("SpO2")}</label>
                                    <input id="spo2" type="number" name="spo2" value={spo2} onChange={(e) => setSpo2(e.target.value)} />
                                </div>
                                <div className="col-md-2 col-6">
                                    <label className={classes.label} htmlFor="allergy">{t("Allergy")}</label>
                                    <input id="allergy" type="text" name="allergy" value={allergy} onChange={(e) => setAllergy(e.target.value)} />
                                </div>
                                <div className="col-md-3 col-6">
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                        <label className={`${classes.label} mb-0`} htmlFor="diagnosys">{t("Diagnosis")}</label>
                                        {authCtx.hospitalData?.boolOPDVoiceCommand && (
                                            <FaMicrophone
                                                onClick={handleVoiceInputForDiagnosis}
                                                style={{
                                                    cursor: "pointer",
                                                    color: isListeningDiagnosis ? "#f44336" : "#25d366",
                                                    animation: isListeningDiagnosis ? "pulse-mic 1s infinite" : "none"
                                                }}
                                                title={t("Voice Input")}
                                            />
                                        )}
                                    </div>
                                    <div className="input-group">
                                        <input className="form-control" id="diagnosys" type="text" placeholder={t("Enter Diagnosis")} value={diagnosis} onChange={handleDiagnosisChange} list="diagnosis-list" />
                                        <datalist id="diagnosis-list">
                                            {diagnosisList.map((d, idx) => (
                                                <option key={idx} value={d} />
                                            ))}
                                        </datalist>
                                        <button type="button" onClick={onSearchPrescriptionType}><i className="fa fa-search pt-1"></i></button>
                                    </div>
                                </div>
                                {visibleFields.includes("lmp") && (
                                    <div className="col-md-3 col-6">
                                        <label className={classes.label} htmlFor="lmp">{t("LMP")}</label>
                                        <input
                                            id="lmp"
                                            className={`form-control ${isHistoryLmp ? classes.highlightedLmp : ""}`}
                                            type="date"
                                            name="lmp"
                                            value={lmp}
                                            min={minLmpDate}
                                            max={today}
                                            onChange={(e) => {
                                                setLmp(e.target.value);
                                                setIsHistoryLmp(false);
                                            }}
                                            title={isHistoryLmp ? t("Auto-filled from medical history within last 6 months") : ""}
                                        />
                                    </div>
                                )}
                                {visibleFields.includes("edd") && (
                                    <div className="col-md-3 col-6">
                                        <label className={classes.label} htmlFor="edd">{t("EDD")}</label>
                                        <input id="edd" className="form-control" type="date" name="edd" value={edd} onChange={(e) => setEdd(e.target.value)} />
                                    </div>
                                )}
                                {visibleFields.includes("length") && (
                                    <div className="col-md-3 col-6">
                                        <label className={classes.label} htmlFor="length">{t("Length")}</label>
                                        <input id="length" className="form-control" type="text" name="length" value={length} onChange={(e) => setLength(e.target.value)} />
                                    </div>
                                )}
                                {visibleFields.includes("hc") && (
                                    <div className="col-md-3 col-6">
                                        <label className={classes.label} htmlFor="hc">{t("Head Circ.")}</label>
                                        <input id="hc" className="form-control" type="text" name="hc" value={hc} onChange={(e) => setHc(e.target.value)} />
                                    </div>
                                )}
                                <div className="col-md-4 col-6">
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                        <label className={`${classes.label} mb-0`} htmlFor="complaint">{t("Complaint")}</label>
                                        {authCtx.hospitalData?.boolOPDVoiceCommand && (
                                            <FaMicrophone
                                                onClick={handleVoiceInputForComplaint}
                                                style={{
                                                    cursor: "pointer",
                                                    color: isListeningComplaint ? "#f44336" : "#25d366",
                                                    animation: isListeningComplaint ? "pulse-mic 1s infinite" : "none"
                                                }}
                                                title={t("Voice Input")}
                                            />
                                        )}
                                    </div>
                                    <textarea className="form-control" rows="1" id="complaint" value={complaint} onChange={(e) => setComplaint(e.target.value)}></textarea>
                                </div>
                                <div className="col-md-4 col-6">
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                        <label className={`${classes.label} mb-0`} htmlFor="advice">{t("Advice")}</label>
                                        {authCtx.hospitalData?.boolOPDVoiceCommand && (
                                            <FaMicrophone
                                                onClick={handleVoiceInputForAdvice}
                                                style={{
                                                    cursor: "pointer",
                                                    color: isListeningAdvice ? "#f44336" : "#25d366",
                                                    animation: isListeningAdvice ? "pulse-mic 1s infinite" : "none"
                                                }}
                                                title={t("Voice Input")}
                                            />
                                        )}
                                    </div>
                                    <textarea
                                        className="form-control"
                                        id="advice"
                                        rows="1"
                                        placeholder={t("Enter Advice")}
                                        value={advice}
                                        onChange={handleAdviceChange}
                                        list="advice-list"
                                    ></textarea>
                                    <datalist id="advice-list">
                                        {adviceList.map((a, idx) => (
                                            <option key={idx} value={a} />
                                        ))}
                                    </datalist>
                                </div>
                                <div className="col-md-4 col-12">
                                    <label className={classes.label} htmlFor="nextAppointment">{t("Next Appointment")}</label>
                                    <input id="nextAppointment" className="form-control" type="date" name="nextAppointment" value={nextAppointment} onChange={(e) => setNextAppointment(e.target.value)} />
                                </div>
                                <div className="col-12 mt-1">
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                        <label className={`${classes.label} mb-0`} htmlFor="notes">{t("Notes")}</label>
                                        {authCtx.hospitalData?.boolOPDVoiceCommand && (
                                            <FaMicrophone
                                                onClick={handleVoiceInputForNotes}
                                                style={{
                                                    cursor: "pointer",
                                                    color: isListeningNotes ? "#f44336" : "#25d366",
                                                    animation: isListeningNotes ? "pulse-mic 1s infinite" : "none"
                                                }}
                                                title={t("Voice Input")}
                                            />
                                        )}
                                    </div>
                                    <textarea id="notes" className="form-control" name="notes" rows="1" value={notes} onChange={(e) => setNotes(e.target.value)} placeholder={t("Add session notes here...")}></textarea>
                                </div>
                            </div>
                        </Form>
                    </div>
                </article>
            </div>
        </>
    );
};

export default CheckedDetails;
